import { type Account } from "@common/modules/account/types";
import React from "react";
import { type LookupAccount } from "../../types";
import { type AddEditRecipientGetDynamicFields } from "../AddUpdateModal";
import BankRecipientPreview from "./Bank";
import CryptoRecipientPreview from "./Crypto";
import { WalletRecipientPreviewDynamic } from "./Wallet";

export type RecipientProps = {
  getDynamicFields: AddEditRecipientGetDynamicFields;
  lookupAccount: LookupAccount;
  recipient: Account.View.Beneficiary;
  style?: React.CSSProperties;
};
const RecipientPreview = (props: RecipientProps) => {
  if (props.recipient.data.crypto) {
    return (
      <CryptoRecipientPreview
        data={props.recipient.data.crypto}
        currencyCode={props.recipient.currencyCode!}
        style={props.style}
      />
    );
  }

  if (props.recipient.data.wallet) {
    return (
      <WalletRecipientPreviewDynamic
        accountNumber={props.recipient.data.wallet.accountNumber}
        lookupAccount={props.lookupAccount}
        style={props.style}
      />
    );
  }

  if (props.recipient.data.wise) {
    return (
      <BankRecipientPreview
        bankName={props.recipient.bankName}
        beneficiaryId={props.recipient.beneficiaryId}
        data={props.recipient.data.wise}
        getDynamicFields={props.getDynamicFields!}
        currencyCode={props.recipient.currencyCode!}
        style={props.style}
      />
    );
  }

  return null;
};
export default RecipientPreview;
